import { SaleType, TrendsKpi } from '@models/Products';
import { Kpi } from '@utils/Formatters';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { SaleTypeMarketKpi } from '@components/products-line-charts/Types';
import React from 'react';
import { PageType } from '@utils/pageConfig/Types';
import {
  createChartAxisConfig,
  processProductsMarketLineChartData,
} from '@data-visualization/utilities/line-chart/FormatLineChartData';
import { ChartKeys } from '@const/ChartKeys';
import { WithLineChart } from '@components/design';
import { useExportImages } from '@hooks/export/UseExportChartImage';
import { generateUniqueChartKeys } from '@data-visualization/utilities/GenerateUniqueChartKeys';

interface Props {
  data: TrendsKpi;
  selectedPeriodicity: Periodicity;
  currency: string;
  selectedLineChartSaleType: SaleType;
}

const ProductsMarketLineChart: React.FC<Props> = ({
  data,
  selectedPeriodicity,
  currency,
  selectedLineChartSaleType,
}) => {
  const { handleExportImage } = useExportImages(PageType.RI_PRODUCT);

  const kpi: Kpi = SaleTypeMarketKpi[selectedLineChartSaleType];

  const chartData = processProductsMarketLineChartData(data, selectedLineChartSaleType);

  return (
    <div data-testid="products-market-line-chart">
      <WithLineChart
        data={chartData}
        fullWidth
        onExport={(image) =>
          handleExportImage(image, generateUniqueChartKeys(chartData, ChartKeys[PageType.RI_PRODUCT].MARKET))
        }
        {...createChartAxisConfig[PageType.RI_PRODUCT][ChartKeys[PageType.RI_PRODUCT].MARKET](
          selectedPeriodicity,
          currency,
          kpi,
        )}
      ></WithLineChart>
    </div>
  );
};

export default React.memo(ProductsMarketLineChart);
